import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import PlayerList from "../../sharedComponents/playerList/PlayerList";
import GameContentContainer from "./GameContentContainer";
import VideoList from "../../sharedComponents/videoList/VideoList";
import auditData from "../../mockData/auditData.json";
import { getBlobsInContainer } from "../../services";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  playerList: {
    width: "240px",
    paddingRight: theme.spacing(2),
  },
  content: {},
  videoList: {
    width: "240px",
    paddingLeft: theme.spacing(2),
  },
  header: {
    zIndex: theme.zIndex.appBar - 1,
    backgroundColor: "#ffffff",
    color: "#000000",
  },
  mainContent: {
    width: "calc(100% - 280px)",
    overflow: "auto",
  },
}));
const drawerWidth = 280;
export default function GameAuditContainer(props) {
  const classes = useStyles();

  const [auditVideoList, setAuditVideoList] = useState([]);
  const [currentPlay, setCurrentPlay] = useState({});
  useEffect(() => {
    const fetchAllData = async () => {
      let data = await getBlobsInContainer();
      setAuditVideoList(data);
      if (data.length > 0) {
        setCurrentPlay(auditData[0]);
      }
    };
    fetchAllData();
  }, []);
  // useEffect(() => {
  //   setAuditVideoList(auditData);
  //   if (auditData.length > 0) {
  //     setCurrentPlay(auditData[0]);
  //   }
  // }, []);

  const handleVideoSelect = (videoInfo) => {
    setCurrentPlay(videoInfo);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <AppBar position="static" className={classes.header}>
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            Audit
          </Typography>
        </Toolbar>
      </AppBar>

      <Box
        component="main"
        sx={{ flexGrow: 1 }}
        className={classes.mainContent}
      >
        <GameContentContainer data={currentPlay} />
      </Box>
      <Drawer
        variant="permanent"
        anchor="right"
        sx={{
          width: drawerWidth,
          zIndex: (theme) => theme.zIndex.appBar - 2,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <Toolbar />
        <Typography
          variant="subtitle2"
          color="#d14360"
          sx={{
            paddingLeft: (theme) => theme.spacing(1),
            paddingTop: (theme) => theme.spacing(2),
            fontWeight: 600,
          }}
        >
          To Be Audited Drills
        </Typography>
        <Box sx={{ overflow: "auto" }}>
          <VideoList
            activeVideo={currentPlay}
            auditVideoList={auditVideoList}
            handleVideoSelect={handleVideoSelect}
          />
        </Box>
      </Drawer>
    </Box>
  );
}
